import {
  Button,
  Drawer,
  Form,
  Input,
  InputNumber,
  Space,
  Typography,
} from "antd";
import axios from "axios";
import React, { useContext, useState } from "react";
import { NotificationInfo, UserInfo } from "../../../context";
import TextArea from "antd/es/input/TextArea";

const NewSaveRawProcessUnsave = ({
  open,
  closeOriginalTab,
  close,
  setLoading,
  getRawProcessUnsaveList,
  getRawProcessList,
  localRawID,
  note,
  multiple,
  checked,
}) => {
  const { rerunNotif } = useContext(NotificationInfo);
  const [loadings, setLoadings] = useState(false);
  const { userData } = useContext(UserInfo);
  const [form] = Form.useForm();

  const handleSaveToRawProcess = (values) => {
    const formdata = new FormData();
    formdata.append("user_id", userData.data.id);
    formdata.append("product", localRawID !== null ? localRawID : "");

    for (const name in values) {
      formdata.append(name, values[name]);
    }
    setLoadings(true);
    setLoading(true);
    axios
      .post("user/commissary/save-raw-process-unsave", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Saved to production successfully.");
          setTimeout(() => {
            close();
            closeOriginalTab();
            setLoadings(false);
            setLoading(false);
            getRawProcessUnsaveList();
            getRawProcessList();
            localStorage.removeItem("BBMSRawID");
          }, 1000);
        }
      })
      .catch((error) => {
        setLoadings(false);
      });
  };

  return (
    <Drawer
      title="Save Prepared Production"
      // width={500}
      onClose={close}
      open={open}
      bodyStyle={{
        paddingBottom: 80,
      }}
    >
      <Form
        form={form}
        layout="vertical"
        name="basic"
        initialValues={{
          category: "",
          description: "",
        }}
        onFinish={handleSaveToRawProcess}
        autoComplete="off"
      >
        <Space direction="vertical" style={{ width: "100%", margin: 0 }}>
          <Typography
            style={{
              fontWeight: "bold",
              fontStyle: "italic",
              marginBottom: 10,
            }}
          >
            Note: {note}
          </Typography>

          {checked && (
            <Form.Item
              // name=""
              label="Multiple of?"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <InputNumber
                min={1}
                max={999999999999}
                value={multiple}
                size="large"
                style={{ width: "100%" }}
                step="1"
                disabled={true}
              />
            </Form.Item>
          )}

          <Form.Item
            name="expected_quantity"
            label="Output Quantity"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <Input
              placeholder="Set output quantity"
              size="large"
              style={{ width: "100%" }}
            />
          </Form.Item>

          <Form.Item
            name="remarks"
            label="Remarks"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <TextArea placeholder="Set remarks" autoSize size="large" />
          </Form.Item>
        </Space>

        <Form.Item style={{ marginTop: "20px" }}>
          <Button
            type="primary"
            loading={loadings}
            htmlType="submit"
            style={{ width: "100%", borderRadius: "20px" }}
          >
            {loadings ? "Loading" : "Save"}
          </Button>
        </Form.Item>
      </Form>
    </Drawer>
  );
};

export default NewSaveRawProcessUnsave;
